import { Nl2Br } from '@findy-code/yuffie/shared/nl2br';

import styles from './job-description-table-element.component.module.scss';

type Props = {
  thText: string;
  tdText: string;
  addLink?: boolean;
};

/**
 * tdTextが空文字なら何も描画しない
 * ※tdTextに様々な要素のデータが入るケースがあり、利用側で描画判定をするのがつらいのでこちらで判定している
 */
export const JobDescriptionTableElement = ({
  thText,
  tdText,
  addLink,
}: Props) =>
  tdText && (
    <tr className={styles.tableRow}>
      <th scope="row">{thText}</th>
      <td>
        <Nl2Br addLink={addLink} text={tdText} />
      </td>
    </tr>
  );
